module.exports = __webpack_public_path__ + "static/img/login_bg1.6cb1cce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/login_bg1.jpg
// module id = 55qK
// module chunks = 3